module.exports = __webpack_public_path__ + "static/media/principalesyotros.a94a5a7f.svg";